import { useStore } from "@tanstack/react-store";
import { useMemo } from "react";
import { defaultTimeZone, getTimeZonesList } from "../../utils/timeZones";
import { IStore, store } from "../../services/store.service";


export  function useTimeZone() {
    const {selected} = useStore(store,(s:any) => s.timeZone);
    const options = useMemo(()=> getTimeZonesList(), []);


    const current = options.find((t) => t.value === selected) ||
    options.find((t) => t.value === defaultTimeZone);

    const selectTimeZone = (value: string) => {
        store.setState((s:IStore) => ({
            ...s,
            timeZone: {...s.timeZone, selected: value},
        }));
        localStorage.setItem("timeZone", JSON.stringify({selected: value}));
    }

    const resetTimeZone = () => selectTimeZone(defaultTimeZone);

    return {
        options,
        current,
        defaultTimeZone,
        selectTimeZone,
        resetTimeZone
    }
}
